export default "__VITE_ASSET__B4pc0XUP__"